import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
import moment from 'moment';
import { momentToiCalDate } from '@square/dashboard-items-data/utils/dates';

// Using 2017 (or any more recent year than the epoch) prevents false positives with weekly schedules if you
// have a time frame that overlaps the current date. There is a bug in old versions of the cross-platform app
// that fast forwarded the time from 1970 to the current date which caused this issue.
const BASE_DATE = moment.utc(0).year(2017);
export default ItemsV3Serializer.extend({
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    function updateDateTime(payload) {
      if (!payload.date_time_start) {
        payload.date_time_start = momentToiCalDate(BASE_DATE);
      }
    }
    if (Array.isArray(payload)) {
      payload.forEach(updateDateTime);
    } else {
      updateDateTime(payload);
    }
    return this._super(store, primaryModelClass, payload, id, requestType);
  }
});